import Check from '@mui/icons-material/Check';
import { Chip, Grid, Tooltip } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/botao.css';
import ReactComponent from '../ReactComponent';

class FiltroRapidoRelator extends ReactComponent {
    handleClickFiltroRelator = (relator) => {
        setTimeout(() => this.alterarValorFiltroRelator(relator), 1);
    };

    alterarValorFiltroRelator = (relator) => {
        if (this.isRelatorAtivoFiltro(relator)) {
            this.filtroNomeRelator.valor = this.filtroNomeRelator.valor.filter(
                (valorFiltro) => valorFiltro !== relator
            );
        } else {
            if (this.filtroNomeRelator.valor && Array.isArray(toJS(this.filtroNomeRelator.valor))) {
                this.filtroNomeRelator.valor.push(relator);
            } else {
                this.filtroNomeRelator.valor = [relator];
            }
        }
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            handleClickFiltroRelator: action,
            alterarValorFiltroRelator: action,
            filtroNomeRelator: computed,
            relatores: computed,
            totalizadoresProcessosPorRelator: computed
        });
    }

    get filtroNomeRelator() {
        return this.store.filtros.filtroNomeRelator;
    }

    get relatores() {
        if (this.store.filtros.existeFiltroRapidoComValor) {
            return this.store.relatoresSessaoComFiltro;
        }
        return this.store.relatoresSessao;
    }

    get totalizadoresProcessosPorRelator() {
        let retorno = [];
        this.relatores.forEach((relator) => {
            let totalizadores = [];
            this.store.opcoesProcessosEmExibicao.forEach((opcaoProcessos) => {
                totalizadores.push({
                    descricao: opcaoProcessos.descricao,
                    quantidadeFiltrados: this.filtroNomeRelator.filtrar(this.getProcessos(opcaoProcessos), relator)
                        .length
                });
            });
            retorno.push({ relator: relator, totalizadores: totalizadores });
        });
        return retorno;
    }

    getProcessos(opcaoProcessos) {
        if (this.store.filtros.existeFiltroRapidoComValor) {
            return opcaoProcessos.funcaoProcessosFiltrados();
        }
        return opcaoProcessos.funcaoProcessos();
    }

    qtdPendentes(relator) {
        if (this.isSalaSessao) {
            return this.store.processosPendentesRelator(relator).length;
        }
        return -1;
    }

    tooltipRelator(relator) {
        let totalizadoresRelator = this.totalizadoresProcessosPorRelator.find(
            (totalizador) => relator === totalizador.relator
        );
        let labelRelator = this.store.getLabelRelator(relator);
        return (
            <>
                <div style={{ fontSize: '1rem' }}>{`Filtrar Relator(a): ${labelRelator}`}</div>
                {' ('}
                {totalizadoresRelator &&
                    totalizadoresRelator.totalizadores.map((totalizador, index) => (
                        <span key={this.nextKey}>
                            {totalizador.descricao +
                                ': ' +
                                totalizador.quantidadeFiltrados +
                                (index < totalizadoresRelator.totalizadores.length - 1 ? ' / ' : '')}
                        </span>
                    ))}
                {')'}
            </>
        );
    }

    isRelatorAtivoFiltro(relator) {
        return (
            this.store.filtros.filtroNomeRelator.valor &&
            this.store.filtros.filtroNomeRelator.valor.findIndex((valorFiltro) => valorFiltro === relator) !== -1
        );
    }

    render() {
        return (
            <div style={{ maxHeight: '150px' }}>
                <Grid
                    container
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    {this.relatores.map((relator) => (
                        <Grid
                            item
                            key={relator}
                        >
                            <Tooltip
                                placement="right"
                                title={this.tooltipRelator(relator)}
                            >
                                <Chip
                                    label={relator.split('||')[0]}
                                    onClick={() => this.handleClickFiltroRelator(relator)}
                                    style={{
                                        height: '24px',
                                        margin: '8px',
                                        fontSize: 12,
                                        cursor: 'pointer',
                                        color: this.isRelatorAtivoFiltro(relator) ? red[900] : 'black'
                                    }}
                                    icon={
                                        this.qtdPendentes(relator) === 0 ? (
                                            <Check style={{ width: '16px', color: 'darkgreen' }} />
                                        ) : null
                                    }
                                />
                            </Tooltip>
                        </Grid>
                    ))}
                </Grid>
            </div>
        );
    }
}

export default inject('stores')(observer(FiltroRapidoRelator));
